import axios from 'axios';

export interface TimeLog {
  _id?: string;
  date: Date | string;
  title: string;
  hours: number;
  tasks: string[];
  businessValue: string[];
  category: 'Planning' | 'Development' | 'Testing' | 'Documentation' | 'Learning' | 'Bug Fixes' | 'Refactoring' | 'Performance' | 'Security' | 'Deployment' | 'Other';
  status: 'completed' | 'planned' | 'in-progress';
  userId?: string;
  createdBy?: any;
  updatedBy?: any;
  createdAt?: Date;
  updatedAt?: Date;
}

export interface TimeLogStats {
  summary: {
    totalHours: number;
    totalEntries: number;
    completedEntries: number;
    plannedEntries: number;
    avgHoursPerEntry: number;
  };
  categoryBreakdown: Array<{
    _id: string;
    hours: number;
    count: number;
  }>;
}

const timeLogService = {
  // Get all time logs with optional filters
  getAll: async (filters?: { startDate?: string; endDate?: string; status?: string }) => {
    const params = new URLSearchParams();
    if (filters?.startDate) params.append('startDate', filters.startDate);
    if (filters?.endDate) params.append('endDate', filters.endDate);
    if (filters?.status) params.append('status', filters.status);
    
    const response = await axios.get(`/timelogs?${params.toString()}`, {
      withCredentials: true
    });
    return response.data;
  },

  // Get statistics
  getStats: async () => {
    const response = await axios.get<{ success: boolean; data: TimeLogStats }>(
      '/timelogs/stats',
      { withCredentials: true }
    );
    return response.data;
  },

  // Get single time log
  getById: async (id: string) => {
    const response = await axios.get(`/timelogs/${id}`, {
      withCredentials: true
    });
    return response.data;
  },

  // Create new time log
  create: async (timeLog: Omit<TimeLog, '_id' | 'userId' | 'createdAt' | 'updatedAt'>) => {
    const response = await axios.post('/timelogs', timeLog, {
      withCredentials: true
    });
    return response.data;
  },

  // Update time log
  update: async (id: string, timeLog: Partial<TimeLog>) => {
    const response = await axios.put(`/timelogs/${id}`, timeLog, {
      withCredentials: true
    });
    return response.data;
  },

  // Delete time log
  delete: async (id: string) => {
    const response = await axios.delete(`/timelogs/${id}`, {
      withCredentials: true
    });
    return response.data;
  }
};

export default timeLogService;
